import { Button, Form, Modal } from "react-bootstrap";
import Loading from "../loading/Loading";
import { useEffect, useState } from "react";
import { getComunidad, getCoordinadoresDeEquipoRoles, removeTeamMember, setOrgToken, updateTeamMember } from "../../controllers/org";
import { useAuth } from "../auth/AuthProvider";

function MemberChangeTeamModal({ show, handleClose, comunidadId, etapaId, equipoId, onSuccess, membershipId }) {
  const [members, setMembers] = useState([]);
  const { token } = useAuth();
  const [equipos, setEquipos] = useState([]);
  const [nuevoEquipo, setNuevoEquipo] = useState(0);
  const [coordinadoresDeEquipoRoles, setCoordinadoresDeEquipoRoles] = useState();
  const [error, setError] = useState();
  setOrgToken(token);

  useEffect(() => {
      loadData();
      loadCoordinadoresDeEquipoRoles();
  }, []);

  async function loadCoordinadoresDeEquipoRoles() {
    let r = await getCoordinadoresDeEquipoRoles();
    setCoordinadoresDeEquipoRoles(r);
  }

  async function loadData() {
    try {
      let r = await getComunidad(comunidadId);
      console.log('equipoId: ' + equipoId);
      const eq = r.equipos.filter(eq => eq.etapa_id === etapaId && eq.team_id !== parseInt(equipoId));
      setEquipos(eq);
      setMembers(r.members.members.rows);
    }
    catch (e) {
      console.log(e);
      if (e.status === 403) {
        setError(<>
          <p>Parece que no tienes permitido cambiar miembros de equipo.</p>
          <p>Por favor contacta a un matrimonio del Equipo Coordinador de Comunidad para que haga el cambio.</p>
        </>)
      }
      else {
        setError(<>
          <p>Ocurrió un error inesperado.</p>
          <p>Por favor intenta de nuevo más tarde.</p>
        </>)
      }
    }
  }

  function renderEquipos() {
    return equipos.map((equipo, i) => {
      let miembrosEquipo = members.filter(m => {
        return equipo.team_members.find(tm => tm.membership_id === m.membership_id);
      });
      const coordinador = miembrosEquipo.find(m => {
        if (m.membership_roles.find(mr => mr.role_id === coordinadoresDeEquipoRoles[equipo.etapa.type])) {
          return m;
        }
      });
      return <option value={equipo.team_id}>{coordinador.label} (Equipo: {equipo.team_id})</option>;
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (nuevoEquipo === 0) {
      try {
        await removeTeamMember(equipoId, membershipId);
      }
      catch (e) {
        console.error(`Error removing team member`, e);
      }
    }
    else {
      try {
        await updateTeamMember(equipoId, membershipId, nuevoEquipo);
      }
      catch (e) {
        console.error(`Error removing team member`, e);
      }
    }

    if (onSuccess && typeof onSuccess === 'function') {
      onSuccess();
    }
    else {
      window.location.hash = '#miembros';
      window.location.reload();
    }
  }

  if (error) {
    return <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Cambiar de Equipo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Cancelar</Button>
      </Modal.Footer>
    </Modal>
  }
  if (!members.length) {
    return <Modal show={show} onHide={handleClose}>
      <Modal.Body>
        <Loading />
      </Modal.Body>
    </Modal>
  }

  return <Modal show={show} onHide={handleClose}>
    <Form onSubmit={handleSubmit}>
      <Modal.Header closeButton>
        <Modal.Title>Cambiar de Equipo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Matrimonio: {members.filter(member => member.membership_id === membershipId)[0]?.label}</p>
        <Form.Group className="mb-3">
          <Form.Label>Selecciona el nuevo equipo</Form.Label>
          <Form.Select onChange={e => setNuevoEquipo(parseInt(e.target.value))} value={nuevoEquipo}>
            <option value={0}>Sacar de equipo</option>
            {renderEquipos()}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-3 submit-buttons-wrapper">
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Cancelar</Button>
        <Button key='submit-btn-new-equipo' type='submit' variant='primary' onClick={handleSubmit}>Guardar</Button>
      </Modal.Footer>
    </Form>
  </Modal>;
}

export default MemberChangeTeamModal;
